import { render, staticRenderFns } from "./task.vue?vue&type=template&id=99a33316"
import script from "./task.vue?vue&type=script&lang=tsx"
export * from "./task.vue?vue&type=script&lang=tsx"
import style0 from "./task.vue?vue&type=style&index=0&id=99a33316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports